import type { SessionView } from "@control-plane/contracts";

type ErrorPayload = { error?: { code?: string; message?: string; requestId?: string; details?: unknown } };

export class ApiClientError extends Error {
  constructor(readonly status: number, readonly code: string, message: string, readonly requestId?: string, readonly details?: unknown) {
    super(message);
  }
}

let csrfToken = "";
export function setCsrfToken(token: string) { csrfToken = token; }
export function csrfHeader() { return csrfToken ? { "x-csrf-token": csrfToken } : {}; }

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = init.method?.toUpperCase() ?? "GET";
  const response = await fetch(path, {
    ...init,
    credentials: "include",
    headers: {
      ...(init.body ? { "content-type": "application/json" } : {}),
      ...(!["GET", "HEAD"].includes(method) && csrfToken ? { "x-csrf-token": csrfToken } : {}),
      ...init.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const body = await response.json().catch(() => ({})) as T & ErrorPayload;
  if (!response.ok) throw new ApiClientError(response.status, body.error?.code ?? "REQUEST_FAILED", body.error?.message ?? "请求失败", body.error?.requestId, body.error?.details);
  return body;
}

export const authApi = {
  session: async () => {
    const session = await api<SessionView>("/api/auth/session");
    setCsrfToken(session.csrfToken);
    return session;
  },
  login: async (email: string, password: string) => {
    const session = await api<SessionView>("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });
    setCsrfToken(session.csrfToken);
    return session;
  },
  loginWithMfa: async (email: string, password: string, totpCode: string) => {
    const session = await api<SessionView>("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password, totpCode }) });
    setCsrfToken(session.csrfToken);
    return session;
  },
  logout: () => api<void>("/api/auth/logout", { method: "POST" }),
};
